import { Button } from "~/components/ui/button";
import { m as messages } from "~/lib/i18n";
import { cn } from "~/lib/utils";

interface OnboardingV1RetryStateProps {
  readonly className?: string;
  readonly onRetry: () => void;
}

export function OnboardingV1RetryState(props: OnboardingV1RetryStateProps) {
  return (
    <div
      className={cn("onboarding-v1__retry-state", props.className)}
      role="alert"
    >
      <p>{messages.onboarding_v1_pick_error()}</p>
      <Button onClick={props.onRetry} type="button" variant="secondary">
        {messages.onboarding_v1_pick_retry_action()}
      </Button>
    </div>
  );
}
